import { render, staticRenderFns } from "./BenchOverview.vue?vue&type=template&id=118874aa&scoped=true&"
import script from "./BenchOverview.vue?vue&type=script&lang=js&"
export * from "./BenchOverview.vue?vue&type=script&lang=js&"
import style0 from "./BenchOverview.vue?vue&type=style&index=0&id=118874aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118874aa",
  null
  
)

export default component.exports